import { ReturnsPage } from '@/app/pages/ReturnsPage';

export function ResponsiveReturnsPage() {
  return <ReturnsPage />;
}
